import React, { useContext, useMemo } from 'react';
import { H4 } from '@zooplus/ui-components';
import { useTranslation } from 'react-i18next';
import { AppShopContext, AppShopContextHolder } from './context/AppShopContext';

const NoHelplineHotlineSection: React.FC = () => {
  const { t } = useTranslation();

  return <p> {t('footer.hotline.working_hours.header')} </p>;
};

const BaseHotlineSection: React.FC = (props: any) => {
  const { t } = useTranslation();

  return (
    <>
      <H4 className="hotlineInfoSection__title">{t('footer.hotline.working_hours.header')}:</H4>
      {props.children}
    </>
  );
};

const RegularDaysHotlineSection: React.FC = () => {
  const { t } = useTranslation();

  const workingHoursEntries = [
    t('footer.hotline.working_hours.monday_to_friday').trim(),
    t('footer.hotline.working_hours.saturday').trim(),
    t('footer.hotline.working_hours.sunday').trim(),
  ];

  return (
    <BaseHotlineSection>
      <ul>
        <Entries entries={workingHoursEntries} />
      </ul>
    </BaseHotlineSection>
  );
};

interface FilteredListProps {
  entries: Array<string>;
}

const Entries: React.FC<FilteredListProps> = ({ entries }) => {
  const filteredEntries = useMemo(() => {
    return entries.filter((entry: string) => !!entry);
  }, [entries]);
  return (
    <>
      {filteredEntries.map((entry: string) => (
        <li key={entry}>{entry}</li>
      ))}
    </>
  );
};

const HotlineInfoSection: any = () => {
  const { domain } = useContext<AppShopContextHolder>(AppShopContext);
  switch (domain) {
    case 'zooplus.gr':
      return <NoHelplineHotlineSection />;
    default:
      return <RegularDaysHotlineSection />;
  }
};

export default HotlineInfoSection;
